module.exports = __webpack_public_path__ + "media/images/top/plan/top-plan-3-36491c9dcfd388cfecc94f1af952672a.png";